<template>
	<div class="line-banner">
		<managing-section class="search-by-enter__container">
			<managing-box :title="titleName">
				<input
					class="search-by-enter__target line-banner__input"
					type="text"
					v-model="searchTarget"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="getSearch">
				검색
			</button>
			<button
				class="btn-main blue bordered"
				type="button"
				@click="resetSearch"
			>
				검색조건 초기화
			</button>
		</div>
		<managing-section :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left line-banner__list__summary">
					검색결과: 전체 {{ total }} 건 (노출 {{ display }}건 / 미노출
					{{ unDisplay }}건)
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>등록일</th>
						<th>
							{{ titleName }}
						</th>
						<th v-if="type === 'home'">타이틀</th>
						<th v-if="type === 'home'">디스크립션</th>
						<th>시작일시</th>
						<th>종료일시</th>
						<th>상태</th>
						<th>관리자명</th>
						<th>삭제</th>
					</tr>
				</thead>
				<tbody>
					<tr
						:class="{ 'line-banner__list__table': item.processed }"
						v-for="item in list"
						:key="item.id"
					>
						<td>{{ item.id }}</td>
						<td>{{ item.createDay || '-' }}</td>
						<td>
							<router-link
								class="line-banner__table-name"
								:to="`/advertisement/${location}/${item.id}`"
								>{{ item.title }}</router-link
							>
						</td>
						<td
							v-if="type === 'home'"
							class="line-banner__table-title"
						>
							{{ item.displayTitle || '-' }}
						</td>
						<td
							v-if="type === 'home'"
							class="line-banner__table-description"
						>
							{{ item.description || '-' }}
						</td>
						<td>{{ item.startDay || '-' }}</td>
						<td>{{ item.endDay || '-' }}</td>
						<td>{{ item.isDisplay ? '노출' : '미노출' }}</td>
						<td>{{ item.nickName || '-' }}</td>
						<td>
							<button class="btn-delete" @click="remove(item.id)">
								삭제
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
		<pagination-box
			slot="pagination"
			class="line-banner__pagination"
			:totalItem="total"
			:offset="offset"
			:limit="limit"
			@to="onPagination($event.offset)"
		/>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PaginationBox from '@/components/PaginationBox';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';
	import moment from 'moment';

	export default {
		name: 'LineBanner',
		props: {
			type: {
				type: String,
				default: 'home',
			},
		},
		components: {
			ManagingSection,
			ManagingBox,
			PaginationBox,
			SearchByEnter,
		},
		computed: {
			titleName() {
				if (this.type === 'home') {
					return '홈DA명';
				}
				if (this.type === 'event') {
					return '이벤트 띠배너명';
				}
				if (this.type === 'product_detail') {
					return '제품상세 띠배너명';
				}
			},
		},
		extends: SearchByEnter,
		data() {
			return {
				total: 0,
				unDisplay: 0,
				display: 0,
				list: [],
				offset: 0,
				limit: 20,
				searchTarget: '',
				location: '',
			};
		},
		created() {
			this.checkLocation();
			this.getList();
		},
		methods: {
			checkLocation() {
				switch (this.type) {
					case 'event':
						this.location = 'event-line-modify';
						break;
					case 'product_detail':
						this.location = 'product-line-modify';
						break;
					default:
						this.location = 'line-banner-modify';
				}
			},
			async getList(search = '') {
				try {
					this.$store.commit('toggleSpinner', true);
					const params = {
						offset: this.offset,
						limit: this.limit,
						title: search,
						location: this.type,
					};
					const { data } = await this.$axiosAdmin2.get(
						`/api/line-banners`,
						{ params }
					);
					this.total = data.total;
					this.unDisplay = data.unDisplayCnt;
					this.display = data.isDisplayCnt;
					this.list = [...data.data];
					this.list.forEach(item => {
						item.startDay = this.getDate(
							item.startAt,
							'YYYY-MM-DD HH:mm'
						);
						item.endDay = this.getDate(
							item.endAt,
							'YYYY-MM-DD HH:mm'
						);
						item.createDay = this.getDate(
							item.createdAt,
							'YYYY-MM-DD'
						);
					});
					this.$store.commit('toggleSpinner', false);
				} catch (err) {
					console.error(err);
					this.$store.commit('toggleSpinner', false);
					alert(
						'리스트 불러오는것을 실패하였습니다. 개발팀에 문의하세요.'
					);
				}
			},
			getDate(date, form = 'YYYY-MM-DD HH:mm:ss') {
				return date && moment(date).format(form);
			},
			getSearch() {
				if (this.searchTarget.trim().length === 0) {
					alert('검색어를 입력해주세요');
					return;
				}
				this.getList(this.searchTarget);
			},
			resetSearch() {
				this.searchTarget = '';
				this.getList();
			},
			async remove(id) {
				try {
					if (confirm('정말 삭제하시겠습니까?')) {
						await this.$axiosAdmin2.delete(
							`/api/line-banner/${id}`
						);
						this.getList(this.searchTarget);
					}
				} catch (err) {
					console.error(err);
					alert(
						'서버통신 오류가 발생하였습니다. 개발팀에 문의하세요.'
					);
				}
			},
			onPagination(offset) {
				this.offset = offset;
				this.getList();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.line-banner {
		.line-banner__list__summary {
			font-weight: bold;
		}
		.line-banner__list__table {
			background: #ffbcce;
		}
		.line-banner__table-name {
			color: #2268b6;
		}
		.line-banner__table-title {
			width: 300px;
		}
		.line-banner__table-description {
			width: 300px;
		}
		.line-banner__pagination {
			margin-top: 30px;
		}
	}
</style>
